import React, {useEffect, useState} from 'react'
import {Form, Input, Checkbox, Button, Row, Col} from 'antd'
import apiRequest from '../../hooks/ApiRequest'
import {toast} from 'react-toastify'

const RoleForm = props => {
  const {form, roleId, onSuccess, modalVisible} = props
  const {getFieldDecorator} = form
  console.log('roleId', roleId, modalVisible)
  useEffect(() => {
    if (!roleId) {
      setSelectedPermissions({})
      form.resetFields()
    }
  }, [roleId])
  const [modules, setModules] = useState([])
  const [selectedPermissions, setSelectedPermissions] = useState({})
  const loadPermissions = async () => {
    const response = await apiRequest(
      process.env.REACT_APP_BASE_URL_AUTH +
        `/api/RoleClaimManager/modules/permissions`,
      'GET',
    )
    if (response?.data) {
      setModules(response.data)
    }
  }
  const fetchRoleDetails = async (id) => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/RoleClaimManager/role-claim/${id}`,
        "GET"
      );
      if (response.success) {
        const { roleName, roleClaims } = response.data;
        form.setFieldsValue({ roleName });
        let parsedRoleClaims;
        if (typeof roleClaims === "string") {
          parsedRoleClaims = JSON.parse(roleClaims);
        } else {
          parsedRoleClaims = roleClaims;
        }
        const selected = {};
        parsedRoleClaims.forEach(({ ModuleId, Permissions }) => {
          selected[ModuleId] = new Set(Permissions.map((p) => p.PermissionId));
        });
  
        console.log("Selected Permissions (Edit Mode):", selected);
        setSelectedPermissions(selected);
      }
    } catch (error) {
      console.error("Error fetching role details:", error);
    }
  };
  
  useEffect(() => {
    const loadData = async () => {
      await loadPermissions();
      if (roleId) {
        await fetchRoleDetails(roleId); 
      } else {
        setSelectedPermissions({});
        form.resetFields();
      }
    };
  
    loadData();
  }, [roleId, modalVisible]);
  

  // Handle checkbox toggle
  const handlePermissionChange = (module, permissionId) => {
    setSelectedPermissions(prev => {
      const newPermissions = {...prev}
      if (!newPermissions[module]) newPermissions[module] = new Set()

      if (newPermissions[module].has(permissionId)) {
        newPermissions[module].delete(permissionId)
      } else {
        newPermissions[module].add(permissionId)
      }

      return {...newPermissions}
    })
  }
  const handleCloseModal = () => {
    setSelectedPermissions({})
    form.resetFields()
    onSuccess()
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (err) return;
      // Format selected permissions into the required structure
      const formattedPermissions = Object.entries(selectedPermissions).map(([moduleId, permissionSet]) => {
        const moduleData = modules.find(mod => mod.moduleId === parseInt(moduleId));
        return {
          moduleId: moduleData.moduleId,
          moduleName: moduleData.moduleName,
          permissions: [...permissionSet].map(permissionId => ({ permissionId }))
        };
      });
      const payload = {
        ...(roleId ? { id: roleId, roleId } : {}), 
        roleName: values.roleName,
        modulePermissions: formattedPermissions
      };
      const url = roleId
        ? `${process.env.REACT_APP_BASE_URL_AUTH}/api/RoleClaimManager/role-claim/add-update`
        : `${process.env.REACT_APP_BASE_URL_AUTH}/api/RoleClaimManager/role-claim/add-update`;
      try {
        const response = await apiRequest(url, "POST", payload);
        if (response.success) {
          toast.success(roleId ? "Role updated successfully" : "Role added successfully");
          handleCloseModal();
        } else {
          toast.error(response.error);
        }
      } catch (error) {
        toast.error("Something went wrong. Please try again.");
      }
    });
  };
  
  return (
    <div className="container mt-3">
      <div className="card p-4">
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Role Name">
                {getFieldDecorator('roleName', {
                  rules: [{required: true, message: 'Role name is required'}],
                })(
                  <Input
                    placeholder="Enter Role Name"
                    className="form-control"
                  />,
                )}
              </Form.Item>
            </Col>
          </Row>
          {/* Permissions Section */}
          <div className="mb-3">
            <h3 className="form-label">Permissions</h3>
            <Row gutter={[16, 16]}>
              {modules.map(({moduleId, moduleName, permissions}) => {
                return (
                  <Col key={moduleId} span={24}>
                    <div className="p-3 border rounded shadow-sm bg-light">
                      <h5 className="mb-3 text-primary">{moduleName}</h5>
                      <Row gutter={[16, 16]}>
                        {permissions.map(({permissionId, permissionName}) => (
                          <Col key={`${moduleId}-${permissionId}`} span={6}>
                            <Checkbox
                              checked={
                                selectedPermissions[moduleId]?.has(
                                  permissionId,
                                ) || false
                              }
                              onChange={() =>
                                handlePermissionChange(moduleId, permissionId)
                              }>
                              {permissionName}
                            </Checkbox>
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </Col>
                )
              })}
            </Row>
          </div>

          <Form.Item>
            <Button type="primary" htmlType="submit" className="btn-success">
              {roleId ? 'Update Role' : 'Add Role'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  )
}

export default Form.create()(RoleForm)
